import SyntaxHighlighter from 'react-syntax-highlighter';
import { atomOneDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import './CustomCode.css'

function CustomCode({codeString, archiveName}) {

  return (
    <>
    <section className="content" style={{ marginTop: '30px' }}>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card card-outline card-info">
              <div className="card-header">
                <h3 className="card-title"><i className="fa-solid fa-pen-to-square mr-1"></i>Código Exemplo</h3>

              </div>
              <div className='ml-3 mt-5 mb-5'>
                <div class="code-box">
                    <div className='title'>
                        <span className='text-sm'>{archiveName}</span>
                    </div>
                    <SyntaxHighlighter language="javascript" style={atomOneDark} customStyle={{
                        padding: "15px"
                    }} wrapLongLines={true}>
                        {codeString}
                    </SyntaxHighlighter>
               </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
);
}

export default CustomCode;